import { render, staticRenderFns } from "./ProfileTwoFactorCodeModal.vue?vue&type=template&id=563db81e&"
import script from "./ProfileTwoFactorCodeModal.vue?vue&type=script&lang=js&"
export * from "./ProfileTwoFactorCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports